import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AREAS } from '../lib/u99';
import { Reveal, Eyebrow } from './Reveal';

const PORTAL_AREAS = AREAS.filter((a) => a.id !== 'home');

export default function United99Portal() {
  return (
    <section id="united99" className="relative py-28 lg:py-40" data-testid="united99-section">
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 50% 40% at 80% 30%, rgba(245,158,11,0.07), transparent 70%)' }} />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <Eyebrow accent="#F59E0B">A separate world · cosmosres.com</Eyebrow>
          <h2 className="font-celestial text-3xl sm:text-4xl lg:text-5xl font-light text-slate-100 leading-tight">United <span className="text-amber-300">99</span> Unleashed</h2>
          <p className="mt-6 text-sm sm:text-base text-slate-400 leading-relaxed max-w-md">Kyle Hinton's doctrines, psychology tools and documents — a site of its own, built on one sequence: experience becomes memory, memory becomes knowing, knowing becomes character.</p>
          <Link to="/u99" className="mt-10 inline-flex items-center gap-3 font-mono-precision text-[11px] uppercase tracking-[0.25em] px-6 py-3.5 rounded-full border border-amber-400/50 text-amber-300 hover:bg-amber-400/10 transition-colors" data-testid="united99-enter-link">Enter United 99 <ArrowRight size={14} /></Link>
        </Reveal>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
          {PORTAL_AREAS.map((a, i) => {
            const Icon = a.icon;
            return (
              <Reveal key={a.id} delay={i * 0.07}>
                <Link to={a.to} className="group block rounded-2xl border border-white/[0.07] hover:border-amber-300/40 p-6 transition-colors duration-500 h-full" data-testid={`united99-area-${a.id}`}>
                  <Icon size={18} strokeWidth={1.5} className="text-amber-300" />
                  <h3 className="mt-4 font-celestial text-lg text-slate-100 group-hover:text-amber-100 transition-colors">{a.label}</h3>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{a.blurb}</p>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
